<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.ZAPI_GROUPS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.ZAPI_GROUPS.DESC')"
    />

    <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.inboxName.$error }">
          {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INBOX_NAME.LABEL') }}
          <input
            v-model.trim="inboxName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INBOX_NAME.PLACEHOLDER')
            "
            @blur="$v.inboxName.$touch"
          />
          <span v-if="$v.inboxName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INBOX_NAME.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.instanceId.$error }">
          {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INSTANCE_ID.LABEL') }}
          <input
            v-model.trim="instanceId"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INSTANCE_ID.PLACEHOLDER')
            "
            @blur="$v.instanceId.$touch"
          />
          <span v-if="$v.instanceId.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.INSTANCE_ID.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.token.$error }">
          {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.TOKEN.LABEL') }}
          <input
            v-model.trim="token"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.ZAPI_GROUPS.TOKEN.PLACEHOLDER')"
            @blur="$v.token.$touch"
          />
          <span v-if="$v.token.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.TOKEN.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.clientToken.$error }">
          {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.CLIENT_TOKEN.LABEL') }}
          <input
            v-model.trim="clientToken"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZAPI_GROUPS.CLIENT_TOKEN.PLACEHOLDER')
            "
            @blur="$v.clientToken.$touch"
          />
          <span v-if="$v.clientToken.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.CLIENT_TOKEN.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%] mt-4">
        <p class="text-sm text-slate-600 dark:text-slate-400">
          {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.HELP_TEXT') }}
          <a
            href="https://developer.z-api.io"
            target="_blank"
            rel="noopener noreferrer"
            class="text-woot-500"
          >
            {{ $t('INBOX_MGMT.ADD.ZAPI_GROUPS.HELP_LINK') }}
          </a>
        </p>
      </div>

      <div class="w-full mt-4">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.ZAPI_GROUPS.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      inboxName: '',
      instanceId: '',
      token: '',
      clientToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
    instanceId: { required },
    token: { required },
    clientToken: { required },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const zapiChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'zapi_groups',
              instance_id: this.instanceId,
              token: this.token,
              client_token: this.clientToken,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: zapiChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.ZAPI_GROUPS.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
